import axios from 'axios';
import { useCallback } from 'react';
import { useCategoryIds, useRetailerId } from 'src/utils/Hooks/reduxSelectors';
import queryString from 'qs';

const useSuggestions = () => {
  const categoryIds = useCategoryIds();
  const retailerId = useRetailerId();

  return useCallback(
    async (originalInput) => {
      const paramsString = queryString.stringify({
        term: originalInput.trim(),
        retailerId,
        type: 'brand',
        categoryIds
      });
      const requestUrl = `/api/atlas/AutoCompleteSuggestions?${paramsString}`;
      try {
        const response = await axios.get(requestUrl);
        const rawCandidates = response?.data?.suggest?.atlas_brand_suggest?.[0]?.options;

        const candidates = rawCandidates.map((candidate) => {
          const source = candidate._source;
          return { brandId: source.brandId, brandName: source.brandName, name: source.name, id: source.id };
        });
        return candidates;
      } catch (error) {
        console.error('Fail to fetch brand suggestion on segment builder page - ', error);
      }
      return [];
    },
    [categoryIds, retailerId]
  );
};

export default useSuggestions;
